import {
  FaBoxOpen,
  FaTag,
  FaWeight,
  FaCheckCircle,
  FaTimesCircle,
  FaStar,
} from "react-icons/fa";

import "./ProvisionDetailsModal.css";

import getImageUrl from "../../../../../../utils/imageUrl";

function ProvisionDetailsModal({
  isOpen,
  onClose,
  product,
}) {
  if (!isOpen || !product) return null;

  const imageUrl = product.image
    ? getImageUrl(product.image)
    : "/images/food-placeholder.png";

  return (
    <div className="provision-modal-overlay">

      <div className="provision-modal">

        <button
          className="close-btn"
          onClick={onClose}
        >
          ×
        </button>

        <div className="modal-image">

          <img
            src={imageUrl}
            alt={product.productName || "Product"}
            onError={(event) => {
              event.currentTarget.src =
                "/images/food-placeholder.png";
            }}
          />

        </div>

        <div className="modal-content">

          <h2>{product.productName}</h2>

          <p className="description">
            {product.description}
          </p>

          <div className="details-grid">

            <div>
              <FaTag />
              <span>Brand</span>
              <strong>{product.brand}</strong>
            </div>

            <div>
              <FaBoxOpen />
              <span>Category</span>
              <strong>{product.category}</strong>
            </div>

            <div>
              <FaTag />
              <span>Price</span>
              <strong>₹{product.price}</strong>
            </div>

            <div>
              <FaTag />
              <span>Offer Price</span>
              <strong>
                ₹{product.offerPrice || product.price}
              </strong>
            </div>

            <div>
              <FaWeight />
              <span>Weight</span>
              <strong>
                {product.weight} {product.unit}
              </strong>
            </div>

            <div>
              <FaBoxOpen />
              <span>Stock</span>
              <strong>{product.stock}</strong>
            </div>

            <div>
              {product.isAvailable ? (
                <FaCheckCircle className="green" />
              ) : (
                <FaTimesCircle className="red" />
              )}

              <span>Status</span>

              <strong>
                {product.isAvailable
                  ? "Available"
                  : "Unavailable"}
              </strong>
            </div>

            <div>
              <FaStar className="yellow" />

              <span>Featured</span>

              <strong>
                {product.isFeatured
                  ? "Yes"
                  : "No"}
              </strong>
            </div>

          </div>

        </div>

      </div>

    </div>
  );
}

export default ProvisionDetailsModal;